import styled from 'styled-components';

export const Container = styled.div`
    padding: 2rem;
    padding-top: 7rem;

    width: 100%;
`;

export const TitleWrapper = styled.div`
    text-align: center;
    height: fit-content;
    margin-bottom: 1.5rem;
`;

export const Title = styled.h2`
    display: inline-block;
    padding: 0.75rem 1rem;
    background-color: ${({ theme }) => theme.colors['supernova-500']};
    font-family: 'Hero New';
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.5rem;
    text-align: left;
    color: ${({ theme }) => theme.colors['neutral-950']};

    @media (max-width: 1200px) {
        font-size: 1.8rem;
        line-height: 1.4rem;
    }

    @media (max-width: 992px) {
        font-size: 1.6rem;
        line-height: 1.3rem;
        padding: 0.6rem 0.8rem;
    }

    @media (max-width: 768px) {
        font-size: 1.4rem;
        line-height: 1.2rem;
        padding: 0.6rem 0.8rem;
    }
`;

export const TopImagesWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 1.5625rem;
    align-items: center;

    width: 100%;

    margin-bottom: 1.5rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 1.25rem;
    gap: 0.625rem;

    @media (max-width: 992px) {
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        row-gap: 1rem;
    }
`;

export const Button = styled.button<{ $isSelected?: boolean }>`
    padding: 0.75rem 1rem;
    background-color: ${({ $isSelected, theme }) =>
        $isSelected
            ? theme.colors['supernova-500']
            : theme.colors['silver-300']};
    border: none;
    border-radius: 0.75rem;
    cursor: pointer;
    font-family: 'Hero New', sans-serif;
    font-size: 1.125rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors['neutral-800']};
    display: flex;
    align-items: center;
    transition: background 0.1s;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;

    @media (max-width: 992px) {
        padding: 0.5rem 0.8rem;
    }
`;

export const ServiceWrap = styled.div`
    height: 100%;
    width: 100%;
    max-width: 80rem;

    margin: auto;

    display: grid;
    grid-template-columns: repeat(auto-fit, 24.8125rem);
    gap: 1.5rem;
    justify-content: center;

    @media (min-width: 1700px) {
        grid-template-columns: repeat(3, 24.8125rem);
    }

    @media (max-width: 768px) {
        grid-template-columns: auto;
    }
`;

export const SVGWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        height: 1.5rem;
        width: 1.5rem;
    }
`;
